var ProductProofTypes;

(function (ProductProofTypes) {
  ProductProofTypes["DEFAULT"] = "default";
  ProductProofTypes["STICKY"] = "sticky";
})(ProductProofTypes || (ProductProofTypes = {}));

var BestOverallVariants;

(function (BestOverallVariants) {
  BestOverallVariants["DEFAULT"] = "default";
  BestOverallVariants["WITH_BACKGROUND"] = "with-background";
  BestOverallVariants["WITH_CROWN"] = "with-crown";
})(BestOverallVariants || (BestOverallVariants = {}));

var ChartReviewsVersions;

(function (ChartReviewsVersions) {
  ChartReviewsVersions["SUMMARY"] = "summary";
  ChartReviewsVersions["PROS_AND_CONS"] = "pros&cons";
  ChartReviewsVersions["PRODUCT_FEATURE"] = "Product Feature";
})(ChartReviewsVersions || (ChartReviewsVersions = {}));

var ProductPromotionDisplayCondition;

(function (ProductPromotionDisplayCondition) {
  ProductPromotionDisplayCondition["BY_PRODUCT"] = "by-product";
  ProductPromotionDisplayCondition["BY_POSITION"] = "by-position";
  ProductPromotionDisplayCondition["BY_PRODUCT_IN_POSITION"] = "by-product-in-position";
})(ProductPromotionDisplayCondition || (ProductPromotionDisplayCondition = {}));

var ProductPromotionSubtextSourceOptions;

(function (ProductPromotionSubtextSourceOptions) {
  ProductPromotionSubtextSourceOptions["TOP3_BOTTOMLINE"] = "top3-bottomline";
  ProductPromotionSubtextSourceOptions["PROMOTIONAL_BADGE"] = "promotional-badge";
  ProductPromotionSubtextSourceOptions["FIRST_BULLET"] = "first-bullet";
  ProductPromotionSubtextSourceOptions["STARS_AND_REVIEWS"] = "stars-and-reviews";
  ProductPromotionSubtextSourceOptions["FALLBACK_TEXT"] = "fallback-text";
})(ProductPromotionSubtextSourceOptions || (ProductPromotionSubtextSourceOptions = {}));

var RightSideLinkDataRoles;

(function (RightSideLinkDataRoles) {
  RightSideLinkDataRoles["ABOUT_US"] = "about-us";
  RightSideLinkDataRoles["AD_DISCLOSURE"] = "ad-disclosure";
  RightSideLinkDataRoles["TERMS_OF_USE"] = "terms-of-use";
  RightSideLinkDataRoles["PARTNER_WITH_US"] = "partner-with-us";
  RightSideLinkDataRoles["PRIVACY_POLICY"] = "privacy-policy";
  RightSideLinkDataRoles["CONTACT_US"] = "contact-us";
  RightSideLinkDataRoles["COOKIE_POLICY"] = "cookie-policy";
  RightSideLinkDataRoles["COOKIE"] = "cookie";
  RightSideLinkDataRoles["SITEMAP"] = "sitemap";
})(RightSideLinkDataRoles || (RightSideLinkDataRoles = {}));

var LeftSideLinkDataRoles;

(function (LeftSideLinkDataRoles) {
  LeftSideLinkDataRoles["BLOG"] = "blog";
  LeftSideLinkDataRoles["DEALS"] = "deals";
})(LeftSideLinkDataRoles || (LeftSideLinkDataRoles = {}));

export { BestOverallVariants, ChartReviewsVersions, LeftSideLinkDataRoles, ProductPromotionDisplayCondition, ProductPromotionSubtextSourceOptions, ProductProofTypes, RightSideLinkDataRoles };
